import ShipmentName from "./ShipmentName";
import ShipmentLink from "./ShipmentLink";


import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";

import TimberStorageName from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import TimberStorageLink from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";

import ContractorUserName from "../../../../timber/components/contractorUser/ContractorUserDetail/ContractorUserName";
import ContractorUserLink from "../../../../timber/components/contractorUser/ContractorUserDetail/ContractorUserLink";

import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";

import BuyerName from "../../../../timber/components/buyer/BuyerDetail/BuyerName";
import BuyerLink from "../../../../timber/components/buyer/BuyerDetail/BuyerLink";

import RoadCarrierName from "../../../../timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierName";
import RoadCarrierLink from "../../../../timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ShipmentDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Shipment-detail-title"
                    >
                        { label || t`Shipment` }: <ShipmentName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Shipment-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Shipment-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="key-label"><Trans>Key</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="key-value" >{ data.key || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="reportKey-label"><Trans>Report Key</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="reportKey-value" >{ data.reportKey || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="cuttingId-label"><Trans>Cutting</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="cuttingId-value" >{ data.cuttingId ? (<CuttingLink id={ data.cuttingId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="storageId-label"><Trans>Timber Storage</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="storageId-value" >{ data.storageId ? (<TimberStorageLink id={ data.storageId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="shipmentAt-label"><Trans>Shipment At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="shipmentAt-value" >{displayDateTime(data.shipmentAt) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="shippingContractorUserId-label"><Trans>Contractor User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="shippingContractorUserId-value" >{ data.shippingContractorUserId ? (<ContractorUserLink id={ data.shippingContractorUserId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="sourceLocationId-label"><Trans>Location</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="sourceLocationId-value" >{ data.sourceLocationId ? (<LocationLink id={ data.sourceLocationId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="sourceParcel-label"><Trans>Source Parcel</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="sourceParcel-value" >{ data.sourceParcel || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="buyerId-label"><Trans>Buyer</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="buyerId-value" >{ data.buyerId ? (<BuyerLink id={ data.buyerId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="targetAddress-label"><Trans>Target Address</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="targetAddress-value" >{ data.targetAddress || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="targetCity-label"><Trans>Target City</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="targetCity-value" >{ data.targetCity || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="targetCountry-label"><Trans>Target Country</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="targetCountry-value" >{ data.targetCountry || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="state-label"><Trans>State</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="state-value" >{ toStringShipmentState(data.state) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="shipmentType-label"><Trans>Shipment Type</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="shipmentType-value" >{ toStringShipmentType(data.shipmentType) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="roadCarrierId-label"><Trans>Road Carrier</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="roadCarrierId-value" >{ data.roadCarrierId ? (<RoadCarrierLink id={ data.roadCarrierId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="truckRegistrationNumber-label"><Trans>Truck Registration Number</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="truckRegistrationNumber-value" >{ data.truckRegistrationNumber || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="truckerName-label"><Trans>Trucker Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="truckerName-value" >{ data.truckerName || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="workOrder-label"><Trans>Work Order</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="workOrder-value" >{ data.workOrder || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="shipmentOrder-label"><Trans>Shipment Order</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="shipmentOrder-value" >{ data.shipmentOrder || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="forPersonalUse-label"><Trans>For Personal Use</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="forPersonalUse-value" >{ data.forPersonalUse ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="description-label"><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="description-value" >{ data.description || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ShipmentDetail;
